import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

const FORM_IDS: Record<string, string> = {
  nl: "0af7a7fb-2698-4822-901f-f9458d0cdf75",
  en: "2e683726-1c24-4d7c-8ed3-86ee0feb9437",
  de: "2e683726-1c24-4d7c-8ed3-86ee0feb9437", // fallback to EN
};

const CustomerFeedback = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const currentLang = lang || "en";
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const formId = FORM_IDS[currentLang] || FORM_IDS.en;
    const container = containerRef.current;
    if (!container) return;

    container.innerHTML = "";

    const div = document.createElement("div");
    div.className = "hs-form-frame";
    div.setAttribute("data-region", "eu1");
    div.setAttribute("data-portal-id", "143197515");
    div.setAttribute("data-form-id", formId);
    container.appendChild(div);

    const script = document.createElement("script");
    script.src = "https://js-eu1.hsforms.net/forms/embed/143197515.js";
    script.defer = true;
    container.appendChild(script);

    return () => {
      container.innerHTML = "";
    };
  }, [currentLang]);

  return (
    <section className="pt-[120px] pb-20 px-6">
      <div className="w-full max-w-7xl mx-auto">
        {/* Title */}
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-16 text-foreground [overflow-wrap:break-word] [hyphens:auto]">
          {t("customerFeedback.title")}
        </h1>

        <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-start">
          {/* Left: description */}
          <div className="space-y-6">
            <p className="text-lg text-muted-foreground leading-relaxed">
              {t("customerFeedback.intro1")}
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed">
              {t("customerFeedback.intro2")}
            </p>
            <p className="text-lg text-muted-foreground leading-relaxed font-medium">
              {t("customerFeedback.intro3")} 🚀
            </p>
          </div>

          {/* Right: HubSpot form */}
          <div ref={containerRef} className="min-h-[400px] px-4" />
        </div>
      </div>
    </section>
  );
};

export default CustomerFeedback;
